import React, { useCallback } from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import AquasecCredentialsForm from './AquasecCredentialsForm'
import AquasecMappingForm from './AquasecMappingForm'
import { columnRenderArrayData } from 'utils/tableUtils';

export default function AquasecConfigListing(props) {
    const getColumns = useCallback((loginConfig) => [{
        title: "Image",
        dataIndex: "imageName",
        render: columnRenderArrayData,
        width: 200
    },
    {
        title: "Scope",
        dataIndex: "scope",
        render: columnRenderArrayData,
        width: 200
    },
    ...(loginConfig.isOnPrem === "false" ? [{
        title: "Repositories",
        dataIndex: "repoName",
        render: columnRenderArrayData,
        width: 200
    }]: []),
    {
        title: "VM Names",
        dataIndex: "vmName",
        render: columnRenderArrayData,
        width: 200
    },
    {
        title: "Function Names",
        dataIndex: "functionName",
        render: columnRenderArrayData,
        width: 200
    },
    {
        title: "Group",
        dataIndex: "groupName",
        render: columnRenderArrayData,
        width: 200
    },
    {
        title: "Cloud Account",
        dataIndex: "accountName",
        render: columnRenderArrayData,
        width: 200
    }
], []);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={AquasecMappingForm}
            CredentialsForm={AquasecCredentialsForm}
            extraColumns={getColumns}
        />
    )
}